export const ZOOM_PROPS = {
    MIN_SCALE: 0.1,
    MAX_SCALE: 3,

    // Alternative scaling maximums
    ZOOM_TO_FIT_MIN_SCALE_MAX: 0.8,
    MANUAL_ZOOM_MIN_SCALE_MAX: 0.25,

    // Scale speed
    SCALE_SPEED_FACTOR: 0.0025,
    INTERPOLATION_FACTOR: 0.25,

    /** Pinch-to-zoom sends small per-frame deltaY; scale before getDesiredScaleFromScroll (cmd/meta zoom unchanged). */
    TRACKPAD_PINCH_STYLE_ZOOM_DELTA_MULTIPLIER: 3,

    // No longer used, but keeping them around as a reminder in case we want to bring it back
    SCALE_OUT_DELTA_LIMIT: 0.8,
    SCALE_IN_DELTA_LIMIT: 1.2,
};

export const ZOOM_MODES = {
    ZOOM_TO_FIT: 'zoom-to-fit',
};

export const ZOOM_TO_FIT_EVENT_NAME = 'zoomToFit';
